import { useIntl } from "react-intl";
import IntlMessages from "../../../../@richbeauty/utility/IntlMessages";
import { AppInputType } from "../../../../shared/constants/AppEnums";
import {
  COMMON_FORM_ITEM_RULE,
  CUSTOMER_ROLE_NAME,
  TASKS_STATUS,
} from "../../../../shared/constants/AppConst";
import useGetAllUsers from "../../../../hooks/apis/users/useGetAllUsers";
import { getSelectUserCommonProps } from "../../../../@richbeauty/utility/Utils";
import useGetAllCustomerLeads from "../../../../hooks/apis/customerLeads/useGetAllCustomerLeads";
import useGetUsers from "hooks/apis/users/useGetUsers";

const useCreateOrEditTaskFieldConfig = (formData, isCreate) => {
  const { messages } = useIntl();
  const { data: allUsers, isLoading: isLoadingAllUsers } = useGetAllUsers();
  const { data: allLeads, isLoading: isLoadingAllLeads } =
    useGetAllCustomerLeads();
  const { data: nonCustomersRaw, isLoading: isLoadingAllNonCustomers } =
    useGetUsers({
      page: 1,
      take: 1000,
      excludeRole: CUSTOMER_ROLE_NAME,
    });
  const safeAllUsers = Array.isArray(allUsers) ? allUsers : [];
  const safeAllLeads = Array.isArray(allLeads) ? allLeads : [];
  const safeNonCustomers = Array.isArray(nonCustomersRaw?.data)
    ? nonCustomersRaw?.data
    : [];
  const selectUserCommonProps = getSelectUserCommonProps({
    users: safeAllUsers,
  });
  const selectLeadCommonProps = getSelectUserCommonProps({
    users: safeAllLeads,
  });
  const selectNonCustomerProps = getSelectUserCommonProps({
    users: safeNonCustomers,
  });

  return [
    {
      type: AppInputType.TEXT_AREA,
      inputConfig: { placeholder: messages["task.name"] },
      formItemConfig: {
        name: "name",
        label: <IntlMessages id="task.name" defaultMessage="Task Name" />,
        rules: [COMMON_FORM_ITEM_RULE.REQUIRED],
      },
    },
    {
      type: AppInputType.DATE_PICKER,
      inputConfig: { placeholder: messages["task.dueDate"] },
      formItemConfig: {
        name: "dueDate",
        label: <IntlMessages id="task.dueDate" defaultMessage="Due Date" />,
        rules: [COMMON_FORM_ITEM_RULE.REQUIRED],
      },
    },
    {
      type: AppInputType.SELECT,
      inputConfig: {
        placeholder: messages["app.customerLeads.status"],
        options: TASKS_STATUS.map(({ value, label }) => ({
          value,
          label,
        })),
        defaultValue: isCreate ? TASKS_STATUS[0].value : undefined,
        hidden: isCreate,
        allowClear: false,
      },
      formItemConfig: {
        name: "status",
        label: <IntlMessages id="app.customerLeads.status" />,
        hidden: isCreate,
      },
    },
    {
      type: AppInputType.SELECT,
      inputConfig: {
        ...selectNonCustomerProps,
        loading: isLoadingAllNonCustomers,
        allowClear: true,
        showSearch: true,
        placeholder: messages["task.assign"] || "Chọn Người phụ trách",
      },
      formItemConfig: {
        name: "assignToId",
        label: <IntlMessages id="task.assign" defaultMessage="assign" />,
      },
    },
    {
      type: AppInputType.SELECT,
      inputConfig: {
        ...selectLeadCommonProps,
        loading: isLoadingAllLeads,
        allowClear: true,
        showSearch: true,
        placeholder: messages["task.lead"] || "Chọn Lead",
        disabled: !!formData?.userId,
      },
      formItemConfig: {
        name: "customerLeadId",
        label: <IntlMessages id="task.lead" defaultMessage="Lead" />,
        disabled: !!formData?.userId,
      },
    },
    {
      type: AppInputType.SELECT,
      inputConfig: {
        ...selectUserCommonProps,
        loading: isLoadingAllUsers,
        allowClear: true,
        showSearch: true,
        placeholder: messages["task.customer"] || "Chọn Customer",
        disabled: !!formData?.customerLeadId,
      },
      formItemConfig: {
        name: "userId",
        label: <IntlMessages id="task.customer" defaultMessage="Customer" />,
        disabled: !!formData?.customerLeadId,
      },
    },
  ];
};

export default useCreateOrEditTaskFieldConfig;
